


























































import { defineComponent } from '@nuxtjs/composition-api'
import NewButton from '@/components/Inputs/new-design/NewButton.vue'
import InputError from '@/components/Inputs/new-design/InputError.vue'

export default defineComponent({
  name: 'BlockPhoneConfirm',
  components: { InputError, NewButton },
  props: {
    phone: {
      type: String,
      default: '',
    },
    isEmailVerify: {
      type: Boolean,
      default: false,
    },
    isCodeSent: {
      type: Boolean,
      required: true,
    },
    disabledButton: {
      type: Boolean,
      default: true,
    },
    timer: {
      type: Number,
      default: 0,
    },
    formattedTimer: {
      type: String,
      default: '00:00',
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasSendButton: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const onSend = () => {
      emit('click-send', props.phone)
    }
    const onResend = () => {
      emit('click-resend', props.phone)
    }

    const onChangePhone = () => {
      emit('click-update-phone')
    }

    return {
      onChangePhone,
      onSend,
      onResend,
    }
  },
})
